import { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col, InputGroup } from 'react-bootstrap';
import { useApi } from '../../contexts/ApiProvider';

export default function NewTripModal({ show, onHide, onSuccess }) {
    const api = useApi();
    const [groups, setGroups] = useState([]);
    const [formData, setFormData] = useState({
        location: '',
        start_date: '',
        end_date: '',
        group_id: '',
        budget_goal: ''
    });

    useEffect(() => {
        if (show) fetchGroups();
        // eslint-disable-next-line
    }, [show]);

    const fetchGroups = async () => {
        const res = await api.get('/travel/groups');
        if (res.ok) {
            setGroups(res.body.items || []);
            if (res.body.items.length > 0) {
                setFormData(prev => ({ ...prev, group_id: res.body.items[0].id }));
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await api.post('/travel/trips', {
            ...formData,
            budget_goal: parseFloat(formData.budget_goal) || 0
        });

        if (res.ok) {
            setFormData({ location: '', start_date: '', end_date: '', group_id: '', budget_goal: '' });
            onSuccess();
            onHide();
        } else {
            alert(res.body?.message || "Failed to create trip.");
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold"><i className="bi bi-airplane-engines text-primary me-2"></i>Initialize New Trip</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold text-muted mb-1">Destination / Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="e.g., Malaysia & Thailand 2026"
                            value={formData.location}
                            onChange={e => setFormData({...formData, location: e.target.value})}
                            required
                        />
                    </Form.Group>

                    <Row className="mb-3">
                        <Col>
                            <Form.Group>
                                <Form.Label className="small fw-bold text-muted mb-1">Start Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={formData.start_date}
                                    onChange={e => setFormData({...formData, start_date: e.target.value})}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label className="small fw-bold text-muted mb-1">End Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={formData.end_date}
                                    onChange={e => setFormData({...formData, end_date: e.target.value})}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold text-muted mb-1">Travel Group (Shared Access)</Form.Label>
                        <Form.Select
                            value={formData.group_id}
                            onChange={e => setFormData({...formData, group_id: e.target.value})}
                            required
                        >
                            <option value="">Select a group...</option>
                            {groups.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label className="small fw-bold text-muted mb-1">Initial Budget Goal (Optional)</Form.Label>
                        <InputGroup>
                            <InputGroup.Text>$</InputGroup.Text>
                            <Form.Control
                                type="number"
                                placeholder="0.00"
                                value={formData.budget_goal}
                                onChange={e => setFormData({...formData, budget_goal: e.target.value})}
                            />
                        </InputGroup>
                    </Form.Group>

                    <Button variant="primary" type="submit" className="w-100 fw-bold rounded-pill">
                        Spin Up Trip Infrastructure
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
